import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/rh/concursos/form_cad'


function CadastrarConcursoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Concurso Público" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarConcursoScreen;